import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the documents menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 * }} params
 * @returns {Array}
 */
export function getDocumentsMenuItems({ businessEntityUuid }) {
  return [
    {
      order: 10,
      title: 'Business Documents',
      itemId: 'documents_business_documents',
      path: generatePath(ROUTES.entityBusinessDocuments, { businessEntityUuid }),
    },
    {
      order: 20,
      title: 'Document Templates',
      itemId: 'documents_document_templates',
      path: generatePath(ROUTES.entityDocumentTemplates, { businessEntityUuid }),
    },
  ];
}

/**
 * Get the documents menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getDocumentsMenu({ businessEntityUuid, order }) {
  // Legacy templates page is hidden, always link directly to business documents
  const menuData = { path: generatePath(ROUTES.entityBusinessDocuments, { businessEntityUuid }) };

  return processMenu({
    title: 'Documents',
    itemId: 'documents',
    icon: 'folder-fill.svg',
    order,
    ...menuData,
  });
}
